export default __webpack_public_path__ + "static/media/laptop-sr.53b5b380.png";